import React, { useEffect, useState } from "react";
import "./Edit_Bet_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Modal_Heading/Modal_Heading";

function Edit_Bet_Modal(props) {

  const [bitPlace, setBitPlace] = useState("");
  const [error, setError] = useState("");

  const gameId = Number(props?.show?.MatkaGame?.id);
  const betType = String(props?.show?.type || "").toLowerCase();

  const motorLength =
    (gameId === 16 || gameId === 17)
      ? String(props?.show?.bit_place || "").length
      : 0;

  // ==========================================
  // GAME NAMES
  // ==========================================

  const matkaGame = {
    1: "Single Digit",
    2: "Jodi",
    3: "Single Patti",
    4: "Double Patti",
    5: "Single Panna",
    6: "Double Panna",
    7: "Triple Panna",
    8: "Triple Patti",
    9: "Half Sangam",
    10: "Full Sangam",
    11: "Jodi Family",
    14: "CYCLE PATTI",
    15: "PANNA FAMILY",
    16: "SP Motor",
    17: "DP Motor",
    18: "One Shot",
  };

  // ==========================================
  // SINGLE DIGIT
  // ==========================================

  const singleDigit = [
    1, 2, 3, 4, 5,
    6, 7, 8, 9, 0
  ];

  // ==========================================
  // JODI
  // ==========================================

  const jodiDigit = [
    "00", "01", "02", "03", "04", "05", "06", "07", "08", "09",
    "10", "11", "12", "13", "14", "15", "16", "17", "18", "19",
    "20", "21", "22", "23", "24", "25", "26", "27", "28", "29",
    "30", "31", "32", "33", "34", "35", "36", "37", "38", "39",
    "40", "41", "42", "43", "44", "45", "46", "47", "48", "49",
    "50", "51", "52", "53", "54", "55", "56", "57", "58", "59",
    "60", "61", "62", "63", "64", "65", "66", "67", "68", "69",
    "70", "71", "72", "73", "74", "75", "76", "77", "78", "79",
    "80", "81", "82", "83", "84", "85", "86", "87", "88", "89",
    "90", "91", "92", "93", "94", "95", "96", "97", "98", "99"
  ];

  // ==========================================
  // SINGLE PANNA
  // ==========================================

  const singlePanna = [
    "128", "137", "146", "236", "245", "290", "380", "470", "489", "560", "579", "678",
    "129", "138", "147", "156", "237", "246", "345", "390", "480", "570", "589", "679",
    "120", "139", "148", "157", "238", "247", "256", "346", "490", "580", "670", "689",
    "130", "149", "158", "167", "239", "248", "257", "347", "356", "590", "680", "789",
    "140", "159", "168", "230", "249", "258", "267", "348", "357", "456", "690", "780",
    "123", "150", "169", "178", "240", "245", "259", "268", "349", "358", "367", "457", "790",
    "124", "160", "179", "250", "269", "278", "340", "359", "368", "458", "467", "890",
    "125", "134", "170", "189", "260", "279", "350", "369", "378", "459", "468", "567",
    "126", "135", "180", "234", "270", "289", "360", "379", "450", "469", "478", "568",
    "127", "136", "145", "190", "235", "280", "370", "389", "460", "479", "569", "578"
  ];

  // ==========================================
  // DOUBLE PANNA
  // ==========================================

  const doublePanna = [
    "100", "119", "155", "225", "227", "335", "344", "399", "588", "669",
    "110", "200", "228", "255", "336", "499", "660", "688", "778",
    "166", "229", "300", "337", "355", "445", "599", "779", "788",
    "112", "220", "266", "400", "446", "455", "699", "770", "338",
    "113", "122", "177", "339", "366", "447", "500", "799", "889",
    "114", "277", "330", "448", "466", "556", "600", "880", "899",
    "115", "133", "188", "223", "377", "449", "557", "566", "700",
    "116", "224", "233", "288", "440", "477", "558", "800", "990",
    "117", "144", "199", "388", "559", "577", "667", "900",
    "118", "226", "244", "299", "334", "488", "550", "668", "677"
  ];

  // ==========================================
  // TRIPLE PANNA
  // ==========================================

  const triplePanna = [
    "111", "222", "333", "444", "555",
    "666", "777", "888", "999", "000"
  ];

  // ==========================================
  // CYCLE PATTI
  // ==========================================

  const cyclePatti = [
    "00", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19",
    "20", "22", "23", "24", "25", "26", "27", "28", "29",
    "30", "33", "34", "35", "36", "37", "38",
    "40", "44", "45", "46", "47", "48", "49",
    "50", "55", "56", "57", "58", "59",
    "60", "66", "67", "68", "69",
    "70", "77", "78", "79",
    "80", "88", "89",
    "90", "99"
  ];

  // ==========================================
  // PANNA FAMILY
  // ==========================================

  const pannaFamily = [
    111, 112, 113, 114, 115,
    122, 123, 124, 125,
    133, 134, 135,
    144, 145, 155,
    222, 223, 224, 225,
    233, 234, 235,
    244, 245, 255,
    333, 334, 335,
    344, 345, 355,
    444, 445, 455, 555
  ];

  // ==========================================
  // JODI FAMILY
  // ==========================================

  const jodiFamily = [
    11, 12, 13, 14, 15,
    22, 23, 24, 25,
    34, 35, 33,
    44, 45, 55
  ];

  // ==========================================
  // LOAD EXISTING VALUE
  // ==========================================

  useEffect(() => {

    setBitPlace(
      props?.show?.bit_place !== undefined &&
        props?.show?.bit_place !== null
        ? String(props.show.bit_place)
        : ""
    );

    setError("");

  }, [props?.show]);

  // ==========================================
  // VALIDATE PANNA
  // ==========================================

  const validatePanna = (value) => {

    if (!/^\d{3}$/.test(value)) {
      return {
        valid: false,
        message: "Panna must contain exactly 3 digits"
      };
    }

    const digits = value.split("");

    // 0 must be last
    if (value.includes("0") && digits[2] !== "0") {
      return {
        valid: false,
        message: "0 must be at the last position"
      };
    }

    const count = {};

    digits.forEach((digit) => {
      count[digit] = (count[digit] || 0) + 1;
    });

    const counts = Object.values(count).sort();

    // ======================================
    // SINGLE PATTI
    // Different digits + ascending
    // ======================================

    if (counts.length === 3) {

      // If 0 exists, first two must ascend
      if (value.includes("0")) {

        if (Number(digits[0]) < Number(digits[1])) {
          return {
            valid: true,
            type: 5
          };
        }

        return {
          valid: false,
          message: "Digits must be in ascending order"
        };
      }

      // Normal ascending
      if (
        Number(digits[0]) < Number(digits[1]) &&
        Number(digits[1]) < Number(digits[2])
      ) {
        return {
          valid: true,
          type: 5
        };
      }

      return {
        valid: false,
        message: "Digits must be in ascending order"
      };
    }

    // ======================================
    // DOUBLE PATTI
    // ======================================

    if (
      counts.length === 2 &&
      counts.includes(2) &&
      counts.includes(1)
    ) {

      if (value.includes("0") && digits[2] !== "0") {
        return {
          valid: false,
          message: "0 must be at the last position"
        };
      }

      return {
        valid: true,
        type: 6
      };
    }

    // ======================================
    // TRIPLE PATTI
    // ======================================

    if (
      counts.length === 1 &&
      counts[0] === 3
    ) {
      return {
        valid: true,
        type: 7
      };
    }

    return {
      valid: false,
      message: "Invalid panna"
    };
  };

  // ==========================================
  // VALIDATE GAME 9 / 10
  // ==========================================

  const validateSangam = (value) => {

    // ======================================
    // HALF SANGAM
    // ======================================

    if (gameId === 9) {

      // OPEN => 127-0
      if (betType === "open") {

        if (!/^\d{3}-\d$/.test(value)) {
          return {
            valid: false,
            message: "Format must be 3 digits-single digit"
          };
        }

        const [panna, digit] = value.split("-");

        const pannaResult = validatePanna(panna);

        if (!pannaResult.valid) {
          return pannaResult;
        }

        if (!/^\d$/.test(digit)) {
          return {
            valid: false,
            message: "Invalid single digit"
          };
        }

        return { valid: true };
      }

      // CLOSE => 0-127
      if (betType === "close") {

        if (!/^\d-\d{3}$/.test(value)) {
          return {
            valid: false,
            message: "Format must be single digit-3 digits"
          };
        }

        const [digit, panna] = value.split("-");

        if (!/^\d$/.test(digit)) {
          return {
            valid: false,
            message: "Invalid single digit"
          };
        }

        const pannaResult = validatePanna(panna);

        if (!pannaResult.valid) {
          return pannaResult;
        }

        return { valid: true };
      }

      return {
        valid: false,
        message: "Type must be open or close"
      };
    }

    // ======================================
    // FULL SANGAM
    // 127-245
    // ======================================

    if (gameId === 10) {

      if (!/^\d{3}-\d{3}$/.test(value)) {
        return {
          valid: false,
          message: "Format must be 3 digits-3 digits"
        };
      }

      const [firstPanna, secondPanna] = value.split("-");

      const firstResult = validatePanna(firstPanna);

      if (!firstResult.valid) {
        return {
          valid: false,
          message: `First panna: ${firstResult.message}`
        };
      }

      const secondResult = validatePanna(secondPanna);

      if (!secondResult.valid) {
        return {
          valid: false,
          message: `Second panna: ${secondResult.message}`
        };
      }

      return { valid: true };
    }

    return {
      valid: false,
      message: "Invalid Sangam"
    };
  };

  // ==========================================
  // HANDLE INPUT CHANGE
  // ==========================================

  const handleChange = (e) => {

    let value = e.target.value;

    // ==========================================
    // SP MOTOR / DP MOTOR
    // ==========================================

    if (gameId === 16 || gameId === 17) {

      value = value.replace(/\D/g, "");
      value = value.slice(0, motorLength);

      setBitPlace(value);
      setError("");

      if (value.length === motorLength) {
        const result = validateMotor(value);

        if (!result.valid) {
          setError(result.message);
        }
      }

      return;
    }

    // Existing logic
    setBitPlace(value);
    setError("");
  };

  // ==========================================
  // HANDLE SANGAM CHANGE
  // ==========================================

  const handleSangamChange = (e) => {

    let value = e.target.value;

    // Only numbers and -
    value = value.replace(/[^\d-]/g, "");

    // Only one -
    const parts = value.split("-");

    if (parts.length > 2) {
      value =
        parts[0] +
        "-" +
        parts.slice(1).join("");
    }

    // ======================================
    // GAME 9 OPEN
    // ======================================

    if (gameId === 9 && betType === "open") {

      const split = value.split("-");

      split[0] = (split[0] || "").slice(0, 3);
      split[1] = (split[1] || "").slice(0, 1);

      value = split.join("-");
    }

    // ======================================
    // GAME 9 CLOSE
    // ======================================

    if (gameId === 9 && betType === "close") {

      const split = value.split("-");

      split[0] = (split[0] || "").slice(0, 1);
      split[1] = (split[1] || "").slice(0, 3);

      value = split.join("-");
    }

    // ======================================
    // GAME 10
    // ======================================

    if (gameId === 10) {

      const split = value.split("-");

      split[0] = (split[0] || "").slice(0, 3);
      split[1] = (split[1] || "").slice(0, 3);

      value = split.join("-");
    }

    setBitPlace(value);

    setError("");
  };

  const validateMotor = (value) => {
    const str = String(value);

    // Length should be same as original bit_place
    const originalValue = String(props?.show?.bit_place || "");
    const requiredLength = originalValue.length;

    // Only numbers
    if (!/^\d+$/.test(str)) {
      return {
        valid: false,
        message: "Only numbers are allowed"
      };
    }

    // Same length as existing bit_place
    if (str.length !== requiredLength) {
      return {
        valid: false,
        message: `Enter exactly ${requiredLength} digits`
      };
    }

    // No repeated digits
    const uniqueDigits = new Set(str.split(""));

    if (uniqueDigits.size !== str.length) {
      return {
        valid: false,
        message: "Digits must not be repeated"
      };
    }

    // 0 can only be at last position
    if (str.includes("0") && str[str.length - 1] !== "0") {
      return {
        valid: false,
        message: "0 must be at the last position"
      };
    }

    // Check ascending order
    // Ignore final 0 because 0 is allowed specially at the end
    const digitsToCheck = str.endsWith("0")
      ? str.slice(0, -1)
      : str;

    for (let i = 1; i < digitsToCheck.length; i++) {
      if (Number(digitsToCheck[i]) <= Number(digitsToCheck[i - 1])) {
        return {
          valid: false,
          message: "Digits must be in ascending order"
        };
      }
    }

    return {
      valid: true
    };
  };

  // ==========================================
  // SAVE
  // ==========================================

  const handleSave = () => {

    // Game 9 / 10
    if (gameId === 9 || gameId === 10) {

      const result = validateSangam(bitPlace);

      if (!result.valid) {
        setError(result.message);
        return;
      }

    }

    // ==========================================
    // GAME 16 / 17 - SP MOTOR / DP MOTOR
    // ==========================================

    if (gameId === 16 || gameId === 17) {

      const result = validateMotor(bitPlace);

      if (!result.valid) {
        setError(result.message);
        return;
      }
    }

    if (
      gameId === 1 ||
      gameId === 3 ||
      gameId === 4 ||
      gameId === 8 ||
      gameId === 18
    ) {

      if (!/^\d$/.test(String(bitPlace))) {
        setError("Please select a valid single digit");
        return;
      }
    }

    if (gameId === 2) {

      if (!/^\d{2}$/.test(String(bitPlace))) {
        setError("Please select a valid Jodi");
        return;
      }
    }

    if (gameId === 5) {

      if (!singlePanna.includes(String(bitPlace))) {
        setError("Please select a valid Single Panna");
        return;
      }
    }

    if (gameId === 6) {

      if (!doublePanna.includes(String(bitPlace))) {
        setError("Please select a valid Double Panna");
        return;
      }
    }

    if (gameId === 7) {

      if (!triplePanna.includes(String(bitPlace))) {
        setError("Please select a valid Triple Panna");
        return;
      }
    }

    if (gameId === 11) {

      if (!jodiFamily.includes(Number(bitPlace))) {
        setError("Please select a valid Jodi Family");
        return;
      }
    }

    if (gameId === 14) {

      if (!cyclePatti.includes(String(bitPlace))) {
        setError("Please select a valid Cycle Patti");
        return;
      }
    }

    if (gameId === 15) {

      if (!pannaFamily.includes(Number(bitPlace))) {
        setError("Please select a valid Panna Family");
        return;
      }
    }

    if (props?.handleFunction) {

      props.handleFunction({
        bit_place: bitPlace,
        id: props?.show?.id,
      });

    }
  };

  // ==========================================
  // RENDER DROPDOWN
  // ==========================================

  const renderSelect = (options, placeholder) => {

    return (
      <Form.Select
        value={String(bitPlace)}
        onChange={handleChange}
        isInvalid={!!error}
      >

        <option value="">
          {placeholder}
        </option>

        {options.map((item, index) => (

          <option
            key={`${item}-${index}`}
            value={String(item)}
          >
            {String(item).padStart(
              gameId === 2 || gameId === 14 || gameId === 11
                ? 2
                : gameId === 15
                  ? 3
                  : 3
            )}
          </option>

        ))}

      </Form.Select>
    );
  };

  // ==========================================
  // RENDER FORM FIELD
  // ==========================================

  const renderBitPlaceField = () => {

    // ======================================
    // GAME 16 / 17 - SP MOTOR / DP MOTOR
    // ======================================

    if (gameId === 16 || gameId === 17) {

      const requiredLength = String(
        props?.show?.bit_place || ""
      ).length;

      return (
        <>
          <Form.Control
            type="text"
            inputMode="numeric"
            value={bitPlace}
            onChange={(e) => {
              let value = e.target.value.replace(/\D/g, "");

              // Do not allow more than original length
              value = value.slice(0, requiredLength);

              setBitPlace(value);
              setError("");
            }}
            placeholder={`Enter ${requiredLength} digit ascending number`}
            maxLength={requiredLength}
            isInvalid={!!error}
          />

          <Form.Control.Feedback type="invalid">
            {error}
          </Form.Control.Feedback>
        </>
      );
    }

    // ======================================
    // GAME 9 / 10
    // ======================================

    if (gameId === 9 || gameId === 10) {

      return (
        <>
          <Form.Control
            type="text"
            inputMode="numeric"
            value={bitPlace}
            onChange={handleSangamChange}
            placeholder={
              gameId === 9
                ? betType === "open"
                  ? "Example: 127-0"
                  : "Example: 0-127"
                : "Example: 127-245"
            }
            isInvalid={!!error}
          />

          <Form.Control.Feedback type="invalid">
            {error}
          </Form.Control.Feedback>
        </>
      );
    }

    // ======================================
    // GAME 1,3,4,8,18
    // ======================================

    if (
      gameId === 1 ||
      gameId === 3 ||
      gameId === 4 ||
      gameId === 8 ||
      gameId === 18
    ) {

      return renderSelect(
        singleDigit,
        "Select Single Digit"
      );
    }

    // ======================================
    // GAME 2
    // ======================================

    if (gameId === 2) {

      return renderSelect(
        jodiDigit,
        "Select Jodi"
      );
    }

    // ======================================
    // GAME 5
    // ======================================

    if (gameId === 5) {

      return renderSelect(
        singlePanna,
        "Select Single Panna"
      );
    }

    // ======================================
    // GAME 6
    // ======================================

    if (gameId === 6) {

      return renderSelect(
        doublePanna,
        "Select Double Panna"
      );
    }

    // ======================================
    // GAME 7
    // ======================================

    if (gameId === 7) {

      return renderSelect(
        triplePanna,
        "Select Triple Panna"
      );
    }

    // ======================================
    // GAME 11
    // ======================================

    if (gameId === 11) {

      return renderSelect(
        jodiFamily,
        "Select Jodi Family"
      );
    }

    // ======================================
    // GAME 14
    // ======================================

    if (gameId === 14) {

      return renderSelect(
        cyclePatti,
        "Select Cycle Patti"
      );
    }

    // ======================================
    // GAME 15
    // ======================================

    if (gameId === 15) {

      return renderSelect(
        pannaFamily,
        "Select Panna Family"
      );
    }

    // ======================================
    // DEFAULT
    // ======================================

    return (
      <Form.Control
        type="text"
        value={bitPlace}
        onChange={handleChange}
        placeholder="Enter bit place"
        isInvalid={!!error}
      />
    );
  };

  return (
    <>
      <section>

        <Modal
          {...props}
          className="Add_Points_Modal modal_holder Edit_Bet_Modal"
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >

          <Modal_Heading modalHeading={props.heading} />

          <div className="modal-body-holder">

            <Modal.Body>

              <div className="main-form-holder">

                <h6 className="text-warning">
                  Market: {props?.show?.Store?.name || "-"}
                </h6>

                <h6 className="text-warning">
                  Game:{" "}
                  {props?.show?.MatkaGame?.name ||
                    matkaGame[gameId] ||
                    "-"}
                </h6>

                <h6 className="text-warning">
                  Type: {props?.show?.type || "-"}
                </h6>

                <h6 className="text-warning">
                  Amount: {props?.show?.amount || "-"}
                </h6>

                <Form className="form-holder">

                  <Form.Group className="mb-3">

                    <Form.Label className="text-white">
                      Bit Place
                    </Form.Label>

                    {renderBitPlaceField()}

                    {error && (
                      <div className="text-danger mt-1">
                        {error}
                      </div>
                    )}

                  </Form.Group>

                </Form>

                <div className="modal-footer-holder">

                  <div className="row">

                    <div className="col-md-6 col-sm-6 col-6">

                      <Button
                        className="search-btn"
                        onClick={props.onHide}
                      >
                        Cancel
                      </Button>

                    </div>

                    <div className="col-md-6 col-sm-6 col-6">

                      <Button
                        className="reset-btn"
                        type="button"
                        onClick={handleSave}
                      >
                        Save
                      </Button>

                    </div>

                  </div>

                </div>

              </div>

            </Modal.Body>

          </div>

        </Modal>

      </section>
    </>
  );
}

export default Edit_Bet_Modal;